import $ from 'jquery';

$(document).on('click', '.js-expand', function(e) {
    e.preventDefault();
    const $this = $(this);
    const $parent = $this.closest('.js-popup');
    $parent.find('.country-columns').addClass('is-expanded');
    $parent.find('.popup__actions .btn--hide-mobile').removeClass('btn--hide-mobile');
    $this.addClass('hidden-xs');
})